import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // Centralized safety net for ALL requests (esp. non-streaming AI calls:
  // /ai/content, /ai/visual, /ai/plan, /ai/event, /ai/help). Without this,
  // a stalled upstream never settles and leaves the calling screen locked in
  // its loading state (button stuck, "chargement infini", refresh required).
  // A bounded timeout guarantees the promise rejects so each caller's
  // catch/finally can reset its loading state and let the user retry.
  timeout: 90000,
});

// Normalize timeouts / network aborts into a consistent, friendly error so
// callers surface a clear message instead of hanging or showing a raw code.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const isTimeout = error?.code === "ECONNABORTED" || /timeout/i.test(error?.message || "");
    if (isTimeout && error?.response == null) {
      error.response = { data: { detail: "Le service IA met trop de temps à répondre. Réessayez dans quelques instants." } };
    }
    return Promise.reject(error);
  }
);

api.interceptors.request.use((config) => {
  try {
    const lang = localStorage.getItem("lb_lang") || "fr";
    config.headers["X-Lang"] = lang;
  } catch { /* localStorage unavailable (private mode) — X-Lang stays default */ }
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
